
import styled from 'styled-components';
import { hexToRgba } from '../utils';

export const StyledChartContainer = styled.ul`
    /* RESET STYLES
    –––––––––––––––––––––––––––––––––––––––––––––––––– */

    margin: 0 auto;
    padding: 0;
    list-style-type: none;
    position: relative;
    width: 100%;
    height: 100%;
    padding-bottom: 50%;
    overflow: hidden;
    
    *,
    &::before {
        box-sizing: border-box;
    }
    
    
    /* chartContainer STYLES
    –––––––––––––––––––––––––––––––––––––––––––––––––– */

    &::before,
    &::after {
        position: absolute;
        left: 0
    }
    
    &::before {
        content: '';
        width: inherit;
        height: inherit;
        border: 8px solid ${({ fillColor }) => hexToRgba(fillColor, 0.2)};
        border-bottom: none;
        border-top-left-radius: 175px;
        border-top-right-radius: 175px;
    }
    
    &::after {
        content: '${({ percentage }) => percentage}%';
        left: 50%;
        bottom: 0px;
        transform: translateX(-50%);
        font-size: 1rem;
        font-weight: bold;
        color: ${({ percentageColor }) => percentageColor};
    }
    
    li {
        position: absolute;
        top: 100%;
        left: 0;
        width: inherit;
        height: inherit;
        border: 8px solid;
        border-top: none;
        border-bottom-left-radius: 175px;
        border-bottom-right-radius: 175px;
        transform-origin: 50% 0;
        transform-style: preserve-3d;
        backface-visibility: hidden;
        animation-fill-mode: forwards;
        animation-duration: .4s;
        animation-timing-function: linear;
    }
    
    li:nth-child(1) {
        z-index: 4;
        border-color: ${({ fillColor }) => fillColor};
        animation-name: rotate-one;
    }
    
    li:nth-child(1) span {
        display: inline-block;
        position: absolute;
        top: -4px;
        left: -8px;
        height: 8px;
        width: 8px;
        background-color: ${({ dotColor }) => dotColor};
        border-radius: 50%;
    }
    
    
    /* ANIMATIONS
    –––––––––––––––––––––––––––––––––––––––––––––––––– */
    
    @keyframes rotate-one {
        100% {
            transform: rotate(${({ percentage }) => (percentage / 100 * 180)}deg);
        }
    }
    
    @keyframes fade-in {
        0%,
        90% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }

    @media (min-width: 768px) {
        &::after {
            font-size: 1.2rem;
        }
    }
`;